import Aos from "aos";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { BiCurrentLocation } from "react-icons/bi";
import { FaPhoneAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { RiWhatsappFill } from "react-icons/ri";
import { connect } from "react-redux";
import { postContact } from "../../modules/actions";
import "./index.scss";
function Contact(props) {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title =
      "Contact Us: More Information | Galaxy Gemological Institute";
  }, []);
  Aos.init({
    delay: 500,
    once: true,
  });
  const [yourName, setYourName] = useState(null);
  const [phoneNo, setPhoneNo] = useState(null);
  const [email, setEmail] = useState(null);
  const [message, setMessage] = useState(null);
  const onSubmit = (e) => {
    let data = {
      yourName: yourName,
      phoneNo: phoneNo,
      email: email,
      message: message,
    };
    props.postContact(data);
  };
  return (
    <div className="ContactUS">
      <Helmet>
        <link rel="canonical" href="https://www.ggilab.com/contact-us" />
        <title>
          Contact Us: More Information | Galaxy Gemological Institute
        </title>
        <meta
          name="description"
          content="We provide a wide range of gemological services, including grading, identification, and certification. Contact us today to learn more about how we can help you."
        />
      </Helmet>
      <div className="ContactInner">
        <div className="SectionOne">
          <h1 data-aos="fade-down">GET IN TOUCH</h1>
          <p data-aos="fade-right">
            Tell Us your Query We will respond you soon.
          </p>
          <div className="ContactColumn">
            <div className="ContactRow">
              {/* <div className="AddressContainer">
								<div className="AddressInner">
									<BiCurrentLocation data-aos="zoom-out-up" className="Icon large" />
									<div data-aos="zoom-out-down">
										<h4 data-aos="zoom-out-right">Karachi Address</h4>
										<p data-aos="zoom-out-right">
											Ground Floor, Mohan Terrace building Sir Jahangir Kothari Trust Shahra-e-Iraq,
											Saddar, Karachi.
										</p>
									</div>
								</div>
								<iframe
									src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3620.1312748587557!2d67.02647711498513!3d24.859365651423794!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33e71f579500b%3A0x515547d0c27720cb!2sGalaxy%20Gemological%20Institute!5e0!3m2!1sen!2s!4v1632540177318!5m2!1sen!2s"
									style={{ border: 0, width: "100%" }}
									allowfullscreen=""
									loading="lazy"
								></iframe>
							</div> */}

              <div className="AddressContainer">
                <div className="AddressInner">
                  <div className="addressIcon">
                    <BiCurrentLocation
                      data-aos="zoom-out-up"
                      className="Icon large"
                    />
                  </div>
                  <div data-aos="zoom-out-down">
                    <h4 data-aos="zoom-out-right">Karachi Address</h4>
                    <p data-aos="zoom-out-right">
                      Ground Floor, Mohan Terrace building Sir Jahangir Kothari
                      Trust Shahra-e-Iraq, Saddar, Karachi.
                    </p>
                  </div>
                </div>
                <iframe
                title="GGI Lab, Karachi"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3620.1312748587557!2d67.02647711498513!3d24.859365651423794!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33e71f579500b%3A0x515547d0c27720cb!2sGalaxy%20Gemological%20Institute!5e0!3m2!1sen!2s!4v1632540177318!5m2!1sen!2s"
                  style={{ border: 0, width: "100%" }}
                  allowfullscreen=""
                  loading="lazy"
                ></iframe>
              </div>

              <div className="AddressContainer">
                <div className="AddressInner">
                  <div className="addressIcon">
                    <BiCurrentLocation
                      data-aos="zoom-out-up"
                      className="Icon large"
                    />
                  </div>
                  <div data-aos="zoom-out-down">
                    <h4 data-aos="zoom-out-right">Peshawar Address</h4>
                    <p data-aos="zoom-out-right">
                      2nd Floor, Anwaar Flats , Shah Qabool Colony#2 Namak Mandi
                      , Peshawar .
                    </p>
                  </div>
                </div>
                <iframe
                title="GGI Lab, Peshawar"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3307.497011319495!2d71.56266951516166!3d34.00545122764218!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38d917c6b19b7bd9%3A0xb0460dc2b600be3f!2sGalaxy%20Gemological%20Insitute!5e0!3m2!1sen!2s!4v1632541222854!5m2!1sen!2s"
                  style={{ border: 0, width: "100%" }}
                  allowfullscreen=""
                  loading="lazy"
                ></iframe>
              </div>
            </div>
            <div className="ContactRow">
              <div className="Address">
                <div className="IconsDiv">
                  <FaPhoneAlt
                    data-aos="zoom-out-up"
                    className="IconWhatApp RedIcon"
                  />
                  <FaPhoneAlt
                    data-aos="zoom-out-up"
                    className="IconWhatApp RedIcon"
                  />
                  <RiWhatsappFill className="IconWhatApp" />
                </div>
                <div data-aos="zoom-out-down">
                  <h4 data-aos="zoom-out-right">Phone Number</h4>
                  <p data-aos="zoom-out-right" className="PhonePara">
                    + 92 (21) 3521-6044 (Karachi)
                  </p>
                  <p data-aos="zoom-out-right" className="PhonePara">
                    +92 (91) 256-8456 (Peshawar)
                  </p>
                  <p
                    data-aos="zoom-out-right"
                    className="WahtsappNumber PhonePara"
                  >
                    +92 324 4425299
                  </p>
                </div>
              </div>

              <div className="Address">
                <div className="IconsDiv">
                  <MdEmail data-aos="zoom-out-up" className="Icon" />
                </div>
                <div data-aos="zoom-out-down">
                  <h4 data-aos="zoom-out-left">Email Address</h4>
                  <p data-aos="zoom-out-right">info@ggilab.com</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="SectionTwo">
          <h2 data-aos="fade-right">Your Query!</h2>
          {props.contact ? (
            <div className="SuccessForm">
              <h2 data-aos="fade-right">
                Your Query Was Received We Would Contact You Back Soon
              </h2>
            </div>
          ) : (
            <div>
              <input
                data-aos="fade-down"
                placeholder="Your Name"
                value={yourName}
                onChange={(e) => setYourName(e.target.value)}
              />
              <div className="ContactRow">
                <input
                  data-aos="fade-down"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <input
                  data-aos="fade-down"
                  placeholder="Phone No."
                  value={phoneNo}
                  onChange={(e) => setPhoneNo(e.target.value)}
                />
              </div>
              <textarea
                data-aos="fade-down"
                placeholder="Message"
                rows="5"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              ></textarea>
              <button data-aos="fade-left" onClick={() => onSubmit()}>
                SEND MESSAGE
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  contact: state.store.contact,
});

export default connect(mapStateToProps, { postContact })(Contact);
